import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useETEditorFormikPoolingType } from 'services/event_types';
import { useUserPoolSidePanel } from './context';
import { setIsETEditorSidePanelOpen } from '../../../../../../../slice';
import { SidePanel } from '../../../../../../components/side_panel';
import { findUserPool, getDefaultUserPoolName } from '../../../helpers';
import { useHostsListData, useUserPoolsData } from '../../../hooks';
import { useHandleApplyAndClose } from '../use_handle_apply_and_close';
import { UserPool } from './user_pool';
const userPoolContainerCss = "ur0j2yi";
const UserPoolContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(userPoolContainerCss, props.className)} />;
});
const footerCss = "fe12pr8";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
export const UserPoolSidePanel = ({
  eventType,
  isLocked
}) => {
  const dispatch = useDispatch();
  const {
    isOpen,
    userPoolUid,
    targetRef,
    minHeight,
    closeUserPoolSidePanel
  } = useUserPoolSidePanel();
  const {
    roundRobinUserPools
  } = useUserPoolsData();
  const {
    isRoundRobin
  } = useETEditorFormikPoolingType();
  const handleApplyAndClose = useHandleApplyAndClose({
    eventType,
    isLocked
  });
  const userPool = findUserPool(roundRobinUserPools, userPoolUid);
  const {
    isHostsEmpty
  } = useHostsListData(userPool, eventType.isTeam);
  useEffect(() => {
    if (isOpen && !userPool && !isRoundRobin) {
      closeUserPoolSidePanel();
    }
  }, [closeUserPoolSidePanel, isOpen, isRoundRobin, userPool]);
  useEffect(() => {
    if (isOpen) {
      dispatch(setIsETEditorSidePanelOpen(true));
    }
    return () => dispatch(setIsETEditorSidePanelOpen(false));
  }, [dispatch, isOpen]);
  if (!isOpen || !userPool && !isRoundRobin) {
    return null;
  }
  const isUserPoolCreation = isRoundRobin ? isHostsEmpty : !userPool?.uuid;
  const headerText = isUserPoolCreation ? I18n.t('publisher.event_type_editor.sections.hosts.round_robin.create_pool') : I18n.t('publisher.event_type_editor.sections.hosts.round_robin.edit_pool');
  const userPoolName = userPool?.name || getDefaultUserPoolName(userPool?.position);
  return <SidePanel targetRef={targetRef} minHeight={minHeight} onClose={handleApplyAndClose} header={<LabelText size="large">
          {isLocked ? userPoolName : headerText}
        </LabelText>}>
      <UserPoolContainer>
        <UserPool eventType={eventType} userPool={userPool} isLocked={isLocked} isRotatingHosts />
        {!isLocked && <Footer>
            <Button onClick={handleApplyAndClose}>
              {I18n.t('publisher.action.apply')}
            </Button>
          </Footer>}
      </UserPoolContainer>
    </SidePanel>;
};

require("./user_pool_side_panel.wyw-in-js.css!=!../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./user_pool_side_panel.js");